<template lang="pug">
    div
        h1.h1(v-if="type === 'h1'") {{ title }}
        h1.h2(v-if="type === 'h2'") {{ title }}
        h3.h3(v-if="type === 'h3'") {{ title }}
        h4.h4(v-if="type === 'h4'") {{ title }}
        h5.h5(v-if="type === 'h5'") {{ title }}
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            title: VueTypes.string.def(''),
            type: VueTypes.string.def('h1'),
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    .h1
        padding-bottom: 0
        margin-bottom: 1rem
        font-size: remify(40px)
        color: $theme.black
        font-weight: 300

    .h3
        @extend .h1
        font-size: 24px
        color: $theme.black

    .h2
        @extend .h1
        color: $theme.black

    .h4
        @extend .h1
        color: $theme.black
        font-size: remify(20px)

    .h5
        @extend .h4
        color: $theme.black

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .h1
            font-size: remify(24px)

    @media screen and (max-width: $grid-breakpoints.sm - 1)
        .h1
            font-size: remify(20 px)
</style>
